import DisplayExportFieldWidget from "./DisplayExportFieldWidget";
// import { useRef } from "react";


// DEFAULT COMPONENT
const JSDisplayValueAsJsonField = (props) => {
  const val = props.val;
  //
  let error = true;
  let errorMsg = null;
  let json;
  try {
    json = JSON.stringify(val);
    error = false;
  } catch (error) {
    console.log(error);
  }
  //
  if (typeof json !== 'string') {
    error = true;
    errorMsg = 'ERROR JSON is not valid!';
  }
  //
  return (
    <>
      <div className="js-widget-value-as-json">
        {
          error ? (
            <div><p className="text-red uu-text-nowrap"><b>{errorMsg}</b></p></div>
          ) : (
            <DisplayExportFieldWidget
              label={"JSON"}
              name={"json_string"}
              val={json}
              _typeof_val={'string'}
              error={error}
              errorMsg={errorMsg}
              btnCopyEnabled={(props.btnCopyEnabled === true)}
            />
          )
        }
      </div>
    </>
  );
};

export default JSDisplayValueAsJsonField;